// @vendors
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom';

// @components
import FooterAdvice from './../components/FooterAdvice/FooterAdvice'
import { AggregatorSecondKeyAuthModal } from 'components/aggregator/aggregatorSecondKeyAuthModal/aggregatorSecondKeyAuthModal';

// @utilities
const { FormattedText } = require('core/i18n').i18n;
import { recordLink,
    PROC_AGGREGATOR,
    PROC_EXPIRED_OTP_FROM_ADVICE,
    PROC_EXPIRED_OTP_CLOSE_ADVICE,
} from 'utilities/tagging';

class AggregatorExpiredOtpAdvice extends Component {

    constructor(props) {
        super(props)

        this.state = {
            showKeyModal: false
        }
    }

    onHandleShowModalKeyModal = (sendNewKey = false) => {
        const { showKeyModal } = this.state;
        const { userBankId, getSecondFactorAuth } = this.props;

        if (sendNewKey) {
            recordLink(PROC_AGGREGATOR, PROC_EXPIRED_OTP_FROM_ADVICE);
            getSecondFactorAuth(userBankId);
        }

        this.setState({
            showKeyModal: !showKeyModal
        })
    }

    handleButtonClick = () => {
        const { genericMessage, getSecondFactorAuth, history } = this.props;
        if (genericMessage) {
            history.push(`/myprofile/global/entities/manage`)
        } else {
            recordLink(PROC_AGGREGATOR, PROC_EXPIRED_OTP_FROM_ADVICE)
            getSecondFactorAuth && this.onHandleShowModalKeyModal()
        }
    }

    handleOnCloseAdvice = () => {
        recordLink(PROC_AGGREGATOR, PROC_EXPIRED_OTP_CLOSE_ADVICE)
    }

    render() {
        const { bankName, genericMessage } = this.props;
        const {showKeyModal} = this.state;
        const messageTitle = `aggregatorExpiredOtpStatus-${genericMessage ? 'genericTitle' : 'title'}`;
        const messageDescription = `aggregatorExpiredOtpStatus-${genericMessage ? 'genericDescription' : 'description'}`;
        const messageButton = `aggregatorExpiredOtpStatus-${genericMessage ? 'genericButtonText' : 'buttonText'}`;

        return (
            <React.Fragment>
                <AggregatorSecondKeyAuthModal
                    showKeyModal={showKeyModal}
                    requestSendingNewOtp={() => this.onHandleShowModalKeyModal(true)}
                    onCloseCallback={() => this.setState({showKeyModal: false})}
                />
                <FooterAdvice
                    title={<FormattedText value={messageTitle} injectedStrings={[bankName]}/>}
                    description={<FormattedText value={messageDescription} injectedStrings={[bankName]}/>}
                    textButton={<FormattedText value={messageButton} />}
                    onClickButton={this.handleButtonClick}
                    onCloseCallback={this.handleOnCloseAdvice}
            />
            </React.Fragment>
        )
    }
}

AggregatorExpiredOtpAdvice.propTypes = {
    history: PropTypes.object.isRequired,
    userBankId: PropTypes.string,
    bankName: PropTypes.string,
    deprecated: PropTypes.bool,
    genericMessage: PropTypes.bool,
    getSecondFactorAuth: PropTypes.func,
}

export default withRouter(AggregatorExpiredOtpAdvice);
